<wiz-vgroup width="100%" height="100%" padding="0px">
  <wiz-hgroup #hgDetailZone verticalAlign="end" gap="10" [visible]="false">
    <wiz-hgroup width="100%" style="overflow: auto"><ng-container #containerFilter></ng-container></wiz-hgroup>
  </wiz-hgroup>

  <wiz-ag-grid #agGrid width="100%" height="100%" 
  class="ag-theme-alpine"
  [frameworkComponents]="gridFrameworkComponents"
  [wizDatasource]="mainDS"
  [widget]="widget"
  [columnDefs]="columns"
  [gridOptions]="gridOptions"
  [wizRowSelection]="'none'"
  [wizShowDelete]="false"
  (wizCellEdit)="onCellEdit($event)"
  (wizCellChecked)="onCellChecked($event)"
  (gridReady)="onGridReady($event)"
  ></wiz-ag-grid>
</wiz-vgroup>
